import {
  Component,
  ComponentFactoryResolver,
  ComponentRef,
  ElementRef,
  Injector,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { config } from '../../../../config/config';
import { ModalService } from '../../../common/services/modal.service';
import { HubPlace, PlaceBusinessStatus } from '../../../models/hub/hub.place';
import { HubApiService } from '../../../services/hub.api.service';
import { ImageService } from '../../../services/image.service';
import { BaseComponent } from '../../../common/components/base.component';
import { MatDialogRef } from '@angular/material';
import { ButtonTriggerEvent } from '../../../common/components';
import { PlaceService } from '../../../services/place.service';
import { EditPlaceImagesModalComponent } from '../edit.place.images.modal/edit.place.images.modal.component';
import { EditPlaceImagesModalActions } from '../edit.place.images.modal/edit.place.images.modal.provider';
import { ShowInfoModalComponent } from '../show.info.modal/show.info.modal.component';
import { InfoModalData, ShowInfoModalActions } from '../show.info.modal/show.info.modal.provider';
import { EditPlaceModalActions } from './edit.place.modal.provider';
import { VisitorDataCache } from '../../../stores/visitor.calendar.store';
import { AlertifyService } from '../../../services/alertify.service';
import { EditPlaceCategoryModalComponent } from '../edit.place.category.modal/edit.place.category.modal.component';
import { EditPlaceCategoryModalActions } from '../edit.place.category.modal/edit.place.category.modal.provider';
import { LocalStorageService } from '../../../services/localStorageService';
import { BulkAIDescriptionsModalComponent } from '../bulk.ai.descriptions.modal/bulk.ai.descriptions.modal.component';
import { BulkAIDescriptionsModalActions } from '../bulk.ai.descriptions.modal/bulk.ai.descriptions.modal.provider';
import { BulkAIDescriptionsStore, ToggleStore } from '../../../stores/hub.calendar.store';
import { TokenInfo } from '../../../models/auth/token.info';
import * as jwt_decode from 'jwt-decode';
import { localStorageKeys } from '../../../common/constants/local.storage.keys';
import { EditManuallyPlaceImagesModalActions } from '../edit.manually.place.images.modal/edit.manually.place.images.modal.provider';
import { EditManuallyPlaceImagesModalComponent } from '../edit.manually.place.images.modal/edit.manually.place.images.modal.component';
import { HubVisitorFeatureToggle } from '../../../models/hub/hub.visitor.feature.toggle';

@Component({
  templateUrl: './edit.place.modal.component.html',
  styleUrls: ['./edit.place.modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class EditPlaceModalComponent extends BaseComponent {
  public place: HubPlace;
  // public initialTopCategoryList = [];
  // public categoryList = [];
  public subCategories = [];
  public isUploadImage = false;
  public createPlaceForm: FormGroup;
  public selectedImageData: string | ArrayBuffer;
  public selectedImageFile: File;
  public imageLink: string;
  public showEditGoogleImagesBtn = false;
  public isImageChanged = false;
  public hasCopyrights = false;
  public hasServes = false;
  public sizeLimit = config.eventImageSizeLimit;
  public lockTip = `Currently Unlocked (default/recommended):  Locking will prevent this field from being updated on future automated refreshes.`;

  public isDescriptionNeedShowMore = false;
  public descriptionEditor;

  public isGeneratingDescription = false;
  public aiGeneratedDescription: any[] = [];

  toggles: HubVisitorFeatureToggle;

  @ViewChild('description') public descriptionArea: ElementRef;
  @ViewChild('descriptionHtml') public descriptionHtml: ElementRef;

  @ViewChild('imageSelector') public imageSelector: ElementRef;
  @ViewChild('img') public imgEle: ElementRef;
  @ViewChild('mask') public mask: ElementRef;
  @ViewChild('upload') public upload: ElementRef;
  @ViewChild('icon') public icon: ElementRef;
  //@ViewChild('descriptionTextarea') public descriptionTextarea: ElementRef;

  constructor(
    private dialogRef: MatDialogRef<EditPlaceModalComponent>,
    private actions: EditPlaceModalActions,
    private hubApiService: HubApiService,
    public imageService: ImageService,
    private alertify: AlertifyService,
    private modalService: ModalService,
    private togglesStore: ToggleStore,
    private formBuilder: FormBuilder,
    private bulkAIDescriptionsStore: BulkAIDescriptionsStore,
    private componentFactoryResolver: ComponentFactoryResolver,
    private injector: Injector,
    data: HubPlace
  ) {
    super();
    this.place = Object.assign({}, data);
    if (!this.place.audio) {
      this.place.audio = { isActive: false, link: '', description: '' };
    }
    this.createForm();
    // this.isUploadImage = imageService.isImUploadedImage(imageService.imageSource(this.place));
    this.selectedImageData = this.isUploadImage ? imageService.imageSource(this.place) : null;
    this.imageLink = !this.isUploadImage ? imageService.imageSource(this.place) : null;
    this.showEditGoogleImagesBtn = this.place.socialName === 'google';

    this.togglesStore.toggleCommand
      .takeUntil(this.isDestroyed)
      .subscribe((toggleCommand: HubVisitorFeatureToggle) => {
        this.toggles = toggleCommand;
      });

    this.imageWayChange();

    this.place.categoryText = PlaceService.allToReadableCategory(this.place.category);

    this.descriptionChange();
    this.setUpHtmlEditor();
  }

  public showEditImagesModal() {
    if (this.place.isManuallyCreated) {
      let actions = <EditManuallyPlaceImagesModalActions>{
        confirm: (event: ButtonTriggerEvent, place, coverImg) => {
          this.place = place;
          this.imageLink = coverImg;
        },
      };

      this.modalService.show({
        component: EditManuallyPlaceImagesModalComponent,
        providers: [
          { provide: EditManuallyPlaceImagesModalActions, useValue: actions },
          { provide: HubPlace, useValue: this.place },
        ],
        panelClass: ['width-modal-50p', 'min-width-800px'],
      });
    } else {
      let actions = <EditPlaceImagesModalActions>{
        confirm: (event: ButtonTriggerEvent, place, coverImg) => {
          this.place = place;
          // take the cover image and it will be uploaded to AWS in the confirm function
          this.imageLink = coverImg;
        },
      };

      this.modalService.show({
        component: EditPlaceImagesModalComponent,
        providers: [
          { provide: EditPlaceImagesModalActions, useValue: actions },
          { provide: HubPlace, useValue: this.place },
        ],
        panelClass: ['width-modal-50p', 'min-width-800px'],
      });
    }
  }

  public showEditCategoryModal() {
    let actions = <EditPlaceCategoryModalActions>{
      confirm: (event: ButtonTriggerEvent, category) => {
        this.place.category = category.category;
        this.place.categoryList = category.categoryList;
        this.place.categoryText = category.categoryText;
      },
    };

    this.modalService.show({
      component: EditPlaceCategoryModalComponent,
      providers: [
        { provide: EditPlaceCategoryModalActions, useValue: actions },
        { provide: HubPlace, useValue: this.place },
      ],
      panelClass: 'width-modal-70p',
    });
  }

  public imageWayChange() {
    setTimeout(() => {
      if (this.isUploadImage) {
        if (this.mask) {
          this.mask.nativeElement.style.height = '40px';
          this.mask.nativeElement.style.cursor = 'pointer';
          this.mask.nativeElement.style.backgroundColor = 'black';
        }
        if (this.upload) {
          this.upload.nativeElement.style.cursor = 'pointer';
          this.upload.nativeElement.style.backgroundColor = '#D3D0D0';
        }
      } else {
        if (this.mask) {
          this.mask.nativeElement.style.height = this.imgEle.nativeElement.height + 'px';
          this.mask.nativeElement.style.cursor = 'default';
          this.mask.nativeElement.style.backgroundColor = 'gray';
        }
        if (this.upload) {
          this.upload.nativeElement.style.cursor = 'default';
          this.upload.nativeElement.style.backgroundColor = '#ececec';
        }
      }
    });
  }

  // public categoryChanged() {
  //     this.place.categoryList = [];
  //     this.categoryList.forEach(x => {
  //         if (this.initialTopCategoryList[x]) {
  //             this.place.categoryList.push(...this.initialTopCategoryList[x]);
  //         } else {
  //             this.place.categoryList.push(x);
  //         }
  //     });
  //     this.place.category = this.place.categoryList.join(', ');
  //     this.place.categoryText = this.place.categoryList.map((x => x.replace(/(_)+/g, " ").upperFirstLetter())).join(', ');
  //     console.log(this.place.category);
  // }

  public async onImageChange($event) {
    this.selectedImageFile = $event.srcElement.files[0];

    if (!!this.selectedImageFile) {
      //if (this.selectedImageFile.size <= this.sizeLimit) {
      let reader = new FileReader();

      reader.onload = (e) => {
        this.selectedImageData = e.target['result'];
        this.imageWayChange();
      };

      reader.readAsDataURL(this.selectedImageFile);
      this.selectedImageFile = await this.imageService.compressImageFile(this.selectedImageFile);
      // } else {
      //     window.alert('This image is too large!');
      //     this.imageSelector.nativeElement.value = '';
      // }

      this.isImageChanged = true;
    }
  }

  public close(): void {
    if (this.actions.cancel) {
      this.actions.cancel();
    }

    this.dialogRef.close();
  }

  public toggleAudioTour() {
    this.place.audio.isActive = !this.place.audio.isActive;
  }

  public get isValid() {
    //return !!(this.isUploadImage ? this.selectedImageFile : this.imageLink);
    return this.place.name && this.place.address;
  }

  public async confirm(event: ButtonTriggerEvent) {
    console.log(this.place.lock);

    if (this.place.youtubeLink && this.place.youtubeLink.indexOf('/watch?v=') < 0) {
      this.alertify.warning('Please specify a correct Youtube video link.');
      event.complete();
      return;
    }

    if (!this.place.category) {
      event.complete();
      this.alertify.warning('Please specify a category.');
      return;
    }

    if (this.place.audio.isActive) {
      if (!this.place.audio.link) {
        event.complete();
        this.alertify.warning('Please add audio tour link.');
        return;
      } else {
        if (!this.isAudioUrl(this.place.audio.link)) {
          event.complete();
          this.alertify.warning('The audio tour link is not an audio file link.');
          return;
        }
      }
    }

    if (!this.place.audio.isActive && this.place.audio.link) {
      this.place.audio.link = null;
      this.place.audio.description = null;
    }

    this.place.title = this.place.name;
    await this.processImage();
    this.processLinks();

    this.place.description = this.descriptionEditor.getContents();
    //Need research why wangEditor get default value is "<p><br></p>" when empty
    // if(this.place.description === "<p><br></p>"){
    //   this.place.description = "";
    // }

    // for CLOSED_PERMANENTLY places, set to unapproved
    if (this.place.business_status === PlaceBusinessStatus.CLOSED_PERMANENTLY) {
      this.place.isApproved = false;
    } else if (this.place.business_status === PlaceBusinessStatus.CLOSED_TEMPORARILY) {
      // for CLOSED_TEMPORARILY places, if isKeepTempClosedPlaceInApproved set to false, set the place to unapproved
      const allSettings = LocalStorageService.getAllBackendSettingsFromLocalStorage();
      if (allSettings && allSettings.customSettings.isKeepTempClosedPlaceInApproved === false) {
        this.place.isApproved = false;
      }
    }

    this.hubApiService
      .updatePlace(this.place.hubName, this.place._id, this.place)
      .subscribe((image) => {
        if (image) {
          if (!this.place.cover) {
            this.place.cover = { source: '', isDefault: false };
          }
          this.place.cover.source = image;
        }

        this.actions.confirm(event, this.place);

        if (!window.location.href.includes('localhost')) {
          const authToken = localStorage.getItem(localStorageKeys.authToken);
          let tokenInfo = jwt_decode<TokenInfo>(authToken);
          try {
            let trackName = 'editPlace - ' + this.place.name;
            window['pendo'].track(trackName, {
              accountId: tokenInfo.userName,
              timestamp: Date.now(),
              hubName: this.place.hubName,
            });
          } catch (error) {
            console.error(error);
          }
        }

        this.dialogRef.close();
      });
  }

  public showChangeHistory() {
    let text = [];
    this.place.changeHistory.forEach((x, i) => {
      text.push(`${++i}. Changed by: ${x.userName}, at ${new Date(x.changedAt).toLocaleString()} `);
    });

    this.modalService.show({
      component: ShowInfoModalComponent,
      providers: [
        { provide: ShowInfoModalActions, useValue: null },
        {
          provide: InfoModalData,
          useValue: new InfoModalData('Result', [], text.length ? text : ['(No records)']),
        },
      ],
      panelClass: 'width-modal-3',
    });
  }

  public lockInfo(field) {
    this.place.lock[field] = !this.place.lock[field];
  }

  public businessStatusChanged(status) {
    console.log(status);
    if (status.value === 'CLOSED_TEMPORARILY') {
      const allSettings = LocalStorageService.getAllBackendSettingsFromLocalStorage();
      if (!allSettings) return;

      if (allSettings.customSettings.isKeepTempClosedPlaceInApproved === false) {
        this.alertify.warning(
          'Set business status to "CLOSED TEMPORARILY" will set this place to unapproved status. If you want to keep it as approved, please set it under "Places" tab" in "Content Management" page.',
          10
        );
      }
    } else if (status.value === 'CLOSED_PERMANENTLY') {
      this.alertify.warning(
        'Set business status to "CLOSED PERMANENTLY" will set this place to unapproved status.',
        6
      );
    }
  }

  public generateDescription() {
    if (this.isGeneratingDescription) return;
    this.isGeneratingDescription = true;
    // this.aiGeneratedDescription = [];
    this.hubApiService
      .aiAssistant(this.place.hubName, {
        query: this.getPlaceNameAndAddress(),
        model: 'chatgpt',
        feature: 'place-description',
      })
      .finally(() => {
        this.isGeneratingDescription = false;
      })
      .subscribe((data: { success: boolean; model: string; data: string }) => {
        if (data.success) {
          try {
            const json = JSON.parse(data.data);
            this.aiGeneratedDescription = [json.version1, json.version2, json.version3];
            console.log(this.aiGeneratedDescription);
            const modal = document.querySelector('.ig-edit-place-modal');
            modal &&
              (modal.className = modal.className.replace('width-modal-1', 'width-modal-70p'));

            this.trackPlaceAIContentAssistant(this.place);
          } catch (err) {
            console.error(err);
          }
        }
      });
  }

  // public selectDescription(description) {
  //   if (this.isRegeneratingDescription) return;

  //   this.place.description = description;
  //   this.descriptionTextarea.nativeElement.classList.remove('ig-fade-in');
  //   this.descriptionTextarea.nativeElement.style.height = '130px';
  //   setTimeout(() => {
  //     this.descriptionTextarea.nativeElement.classList.add('ig-fade-in');
  //   });
  // }

  public selectDescription(description) {
    if (this.isRegeneratingDescription) return;

    this.place.description = description;
    if (this.descriptionHtml) {
      this.descriptionHtml.nativeElement.classList.remove('ig-fade-in');
      this.descriptionHtml.nativeElement.style.height = '130px';
      setTimeout(() => {
        this.descriptionHtml.nativeElement.classList.add('ig-fade-in');
      });
    }
    if (this.descriptionArea) {
      this.descriptionArea.nativeElement.classList.remove('ig-fade-in');
      this.descriptionArea.nativeElement.style.height = '130px';
      setTimeout(() => {
        this.descriptionArea.nativeElement.classList.add('ig-fade-in');
      });
    }

    if (this.descriptionEditor) {
      this.descriptionEditor.setContents(description);
    }
  }

  public get isRegeneratingDescription() {
    return this.aiGeneratedDescription.length && this.isGeneratingDescription;
  }

  public bulkGeneration() {
    const modal = document.querySelector('.ig-bulk-ai-descriptions-modal');
    if (modal) {
      modal.classList.add('ig-shake');
      setTimeout(() => {
        modal.classList.remove('ig-shake');
      }, 1000);
      return;
    }

    this.bulkAIDescriptionsStore.bulkAIDescriptionsCommand.next(this.place.hubName);
    const factory = this.componentFactoryResolver.resolveComponentFactory(
      BulkAIDescriptionsModalComponent
    );
    const componentRef = factory.create(this.injector);

    const appElement = document.querySelector('body');
    const componentRootElement = componentRef.location.nativeElement;
    appElement && appElement.appendChild(componentRootElement);
  }

  private isAudioUrl(url: string): boolean {
    const audioExtensions = ['.mp3', '.wav', '.ogg', '.aac', '.flac', '.m4a', '.mp4'];
    return audioExtensions.some((ext) => url.toLowerCase().endsWith(ext));
  }

  private trackPlaceAIContentAssistant(place: HubPlace) {
    if (!window.location.href.includes('localhost')) {
      const authToken = localStorage.getItem(localStorageKeys.authToken);
      let tokenInfo = jwt_decode<TokenInfo>(authToken);
      try {
        let trackName = 'click - Place - AIContentAssistant - ' + place.name;
        window['pendo'].track(trackName, {
          accountId: tokenInfo.userName,
          timestamp: Date.now(),
          hubName: place.hubName,
        });
      } catch (error) {
        console.error(error);
      }
    }
  }

  private getPlaceNameAndAddress() {
    return `${this.place.name}, ${this.place.address ? this.place.address.address : ''}`;
  }

  // private checkDoesHaveServes() {
  //   for (const serve in this.place?.dine) {
  //     if (Object.prototype.hasOwnProperty.call(this.place?.dine, serve)) {
  //       const element = this.place?.dine[serve];
  //       if (element !== null && element !== undefined) {
  //         this.hasServes = true;
  //         break;
  //       }
  //     }
  //   }
  // }

  public setUpHtmlEditor() {
    setTimeout(() => {
      this.descriptionEditor = window['SUNEDITOR'].create('description-editor', {
        toolbarContainer: '#toolbar_container',
        showPathLabel: false,
        charCounter: true,
        width: 'auto',
        height: 'auto',
        minHeight: '100px',
        maxHeight: '250px',
        value: this.place.description || '',
        buttonList: [
          ['undo', 'redo', 'font', 'fontSize', 'formatBlock'],
          ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript', 'removeFormat'],
          [
            'fontColor',
            'hiliteColor',
            'outdent',
            'indent',
            'align',
            'horizontalRule',
            'list',
            'table',
          ],
          ['link', 'image', 'video', 'fullScreen', 'showBlocks', 'codeView', 'preview', 'print'],
        ],
      });

      this.descriptionEditor.onImageUploadBefore = (files, info, core, uploadHandler) => {
        try {
          this.handleImageUploadBefore(files, info, uploadHandler);
        } catch (err) {
          uploadHandler(err.toString());
        }
      };
    });
  }

  public descriptionChange() {
    setTimeout(() => {
      if (this.descriptionArea && this.descriptionArea.nativeElement) {
        this.descriptionArea.nativeElement.style.height =
          Math.min(this.descriptionArea.nativeElement.scrollHeight, 300) + 'px';
      }
      if (this.descriptionHtml) {
        this.isDescriptionNeedShowMore = this.descriptionHtml.nativeElement.scrollHeight > 150;
      }
    });
  }

  private async processImage() {
    if (this.isUploadImage) {
      if (this.selectedImageFile) {
        let image = await this.imageService.compressImageFileToBase64(
          this.selectedImageFile,
          config.compressImgWidth
        );
        // max limit size is 1MB
        if (image.length > 1000000) {
          image = await this.imageService.compressImageFileToBase64(
            this.selectedImageFile,
            config.compressImgWidth - 200
          );
        }
        // save to AWS album "places/iti-user-upload" to distinguish user load image from place pulled from google image
        // so that if user edit (allow, block) Google images, it will know if need to update cover image accordingly
        const res = await this.hubApiService.uploadBase64ImageToAWS(
          image,
          960,
          'places/iti-user-upload/'
        );
        if (res.success) {
          this.place.cover = { source: '', isDefault: false };
          this.place.cover.source = this.imageLink = this.place.imageLink = res.url;
        }
      } else {
        this.place.imageLink =
          this.imageLink || (this.place.cover && this.place.cover.source) || null;
      }
    } else {
      this.place.imageLink =
        this.imageLink || (this.place.cover && this.place.cover.source) || null;
      if (this.place.imageLink && !this.place.imageLink.includes('amazonaws')) {
        const res = await this.hubApiService.uploadBase64ImageToAWS(
          this.place.imageLink,
          960,
          'places/iti-user-upload/'
        );
        if (res.success) {
          this.place.cover = { source: '', isDefault: false };
          this.place.cover.source = this.imageLink = this.place.imageLink = res.url;
        }
      }
    }
    this.place.imageFile = null;
  }

  private processLinks() {
    this.place.hostLink = this.addLinkPrefix(this.place.hostLink);
    this.place.youtubeLink = this.addLinkPrefix(this.place.youtubeLink);
    this.place.facebookLink = this.addLinkPrefix(this.place.facebookLink);
    this.place.website = this.addLinkPrefix(this.place.website);

    if (this.place.audio.isActive) {
      this.place.audio.link = this.addLinkPrefix(this.place.audio.link);
    }
  }

  private addLinkPrefix(link: string | undefined): string {
    const linkWithPrefix = link ? (link.startsWith('http') ? link : `https://${link}`) : '';
    return linkWithPrefix;
  }

  private processCategory(event: ButtonTriggerEvent) {
    if (this.place.socialName === 'google') {
      /**
       * google place's category is in snake case (e.g., point_of_interests),
       * while imgoing place category display text in place cards and edit popup is like "Point of Interests", and separated by "," when saving to database
       */
      if (this.place.categoryText) {
        let cateSeg = this.place.categoryText.split(',').map((x) => x.trim());

        cateSeg = cateSeg.map((x) => {
          x = x.replace(/( )+/g, '_');
          x = x.toLowerCase();
          return x;
        });
        cateSeg = cateSeg.filter((x) => !!x);
        this.place.categoryList = cateSeg;
        this.place.category = cateSeg.join(', ');
        this.place.categoryText = cateSeg
          .map((x) => x.replace(/(_)+/g, ' ').upperFirstLetter())
          .join(', ');
      } else {
        this.alertify.warning('Please specify a category.');
        event.complete();
        return false;
      }
    } else if (!this.place.category) {
      this.alertify.warning('Please specify a category.');
      event.complete();
      return false;
    }
    return true;
  }

  private createForm() {
    this.createPlaceForm = this.formBuilder.group({
      name: [null, [Validators.required]],
      description: [null, []],
      timeRanges: this.formBuilder.array([]),
      address: [null, [Validators.required]],
      category: [null, []],
      categoryText: [null, []],
      subCategory: [null, []],
      ticketUri: [null, []],
      facebookEvent: [null, []],
      hostLink: [null, []],
      eventLink: [null, []],
      website: [null, []],
      imageLink: [null, []],
      phone: [null, []],
      email: [null, [Validators.pattern(config.emailPattern)]],
      priceRange: [null, []],
      timezone: [null, []],
      _360VideoKey: [null, []],
      youtubeLink: [null, []],
      facebookLink: [null, []],
      ownerEmail: [null, []],
      ownerPhone: [null, []],
      business_status: [null, []],
      audio_link: [null, []],
      audio_description: [null, []],
      audio_is_active: [null, []],
    });
  }

  private handleImageUploadBefore(files, info, uploadHandler) {
    this.imageService
      .getBase64ByImageFile(files[0])
      .then((imageInfo) => {
        if (imageInfo) {
          this.hubApiService
            .uploadBase64ImageToAWS(imageInfo)
            .then((res) => {
              if (res.success) {
                const response = {
                  result: [
                    {
                      url: `${res.url}`,
                      name: files[0].name,
                      size: files[0].size,
                    },
                  ],
                };
                uploadHandler(response);
              } else {
                uploadHandler('upload image fail');
              }
            })
            .catch((err) => {
              uploadHandler('upload image fail');
              console.error(err);
            });
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/edit.place.modal/edit.place.modal.component.ts